import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/app-footer/footer.component';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
/**
 * Represents the root component of the application.
 */
export class AppComponent {
  title = 'cataloguemodule';

  // selectedMenuItem: string;
  // onNavigation(selectedmenu: string) {
  //   this.selectedMenuItem = selectedmenu;
  //   console.log('Selected Menu app component:', selectedmenu);
  //}
}
